module.exports = __webpack_public_path__ + "Material-Design-Iconic-Fontd1f1.b351bd62abcd96e924d9.ttf";


//////////////////
// WEBPACK FOOTER
// /app/src/assets/fonts/iconic/Material-Design-Iconic-Fontd1f1.ttf
// module id = ../../../../../src/assets/fonts/iconic/Material-Design-Iconic-Fontd1f1.ttf
// module chunks = main